import React from "react";
import { C, radii, shadows, space, type } from "../../styles/tokens";

/**
 * AmountSummaryBox (docs/BRAND_MANUAL.md, section 8)
 * Rows on a white card:
 *  - Label left in textMuted
 *  - Sum right in bodyStrong tabular figures
 *  - Hairlines between rows
 *  - "To pay" / total row in heading navy
 *
 * items: [{ label, amount, detail }]
 * total: { label: "To pay", amount }
 */
export function AmountSummaryBox({
  title,
  items = [],
  total,
  footnote,
  style = {},
}) {
  return (
    <div
      style={{
        backgroundColor: C.surface,
        borderRadius: radii.card,
        boxShadow: shadows.card,
        padding: space.lg,
        marginBottom: space.lg,
        boxSizing: "border-box",
        ...style,
      }}
    >
      {title && (
        <div
          style={{
            color: C.navy,
            fontSize: type.heading.fontSize,
            lineHeight: type.heading.lineHeight,
            fontWeight: type.heading.fontWeight,
            marginBottom: space.md,
            paddingBottom: space.sm,
            borderBottom: `1px solid ${C.divider}`,
          }}
        >
          {title}
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column" }}>
        {items.map((item, idx) => (
          <div
            key={item.label || idx}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingTop: idx === 0 ? 0 : space.sm,
              paddingBottom: space.sm,
              borderBottom: `1px solid ${C.divider}`,
            }}
          >
            <div>
              <span
                style={{
                  color: C.textMuted,
                  fontSize: type.body.fontSize,
                  lineHeight: type.body.lineHeight,
                  fontWeight: type.body.fontWeight,
                }}
              >
                {item.label}
              </span>
              {item.detail && (
                <div
                  style={{
                    color: C.textSubtle,
                    fontSize: type.caption.fontSize,
                    marginTop: 2,
                  }}
                >
                  {item.detail}
                </div>
              )}
            </div>
            <span
              style={{
                color: C.textStrong,
                fontSize: type.bodyStrong.fontSize,
                lineHeight: type.bodyStrong.lineHeight,
                fontWeight: type.bodyStrong.fontWeight,
                fontVariantNumeric: "tabular-nums",
              }}
            >
              {item.amount}
            </span>
          </div>
        ))}

        {total && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingTop: space.md,
              marginTop: space.xs,
            }}
          >
            <span
              style={{
                color: C.navy,
                fontSize: type.heading.fontSize,
                lineHeight: type.heading.lineHeight,
                fontWeight: type.heading.fontWeight,
              }}
            >
              {total.label || "To pay"}
            </span>
            <span
              style={{
                color: C.navy,
                fontSize: type.heading.fontSize,
                lineHeight: type.heading.lineHeight,
                fontWeight: type.heading.fontWeight,
                fontVariantNumeric: "tabular-nums",
              }}
            >
              {total.amount}
            </span>
          </div>
        )}
      </div>

      {footnote && (
        <div
          style={{
            marginTop: space.sm,
            color: C.textSubtle,
            fontSize: type.caption.fontSize,
            lineHeight: type.caption.lineHeight,
          }}
        >
          {footnote}
        </div>
      )}
    </div>
  );
}
